import { t } from '@lingui/core/macro'
import { useMemo } from 'react'
import Col from 'react-bootstrap/Col'
import MultiSelect from '~/components/multi_select'
import DashboardFilters from '~/dashboard/dashboard_filters'
import useChartFilters from '~/hooks/use_chart_filters'
import { awsAccountsChartOptionPath } from '~/routes'

export default function AWSEKSDashboardFilters({ organizationId: orgId, possibleValues, setChartParams }) {
  const [onApply, onReset, onChange, params] = useChartFilters(setChartParams)

  const accountsUrl = useMemo(() => awsAccountsChartOptionPath(orgId), [orgId])

  const transform = (key) =>
    possibleValues[key].map((k) => {
      return { value: k, label: k }
    })

  return (
    <DashboardFilters onApply={onApply} onReset={onReset}>
      <Col>
        <MultiSelect
          label={t`Account`}
          name='awsAccountIds'
          onChange={onChange}
          url={accountsUrl}
          selected={params.awsAccountIds}
        />
      </Col>
      <Col>
        <MultiSelect
          label={t`Cluster`}
          name='clusters'
          onChange={onChange}
          options={transform('clusters')}
          selected={params.clusters}
        />
      </Col>
      <Col>
        <MultiSelect
          label={t`Namespace`}
          name='namespaces'
          onChange={onChange}
          options={transform('namespaces')}
          selected={params.namespaces}
        />
      </Col>
      <Col>
        <MultiSelect
          label={t`Deployment`}
          name='deployments'
          onChange={onChange}
          options={transform('deployments')}
          selected={params.deployments}
        />
      </Col>
      <Col>
        <MultiSelect
          label={t`Node`}
          name='nodes'
          onChange={onChange}
          options={transform('nodes')}
          selected={params.nodes}
        />
      </Col>
      <Col>
        <MultiSelect
          label={t`Workload type`}
          name='workload_types'
          onChange={onChange}
          options={transform('workloadTypes')}
          selected={params.workload_types}
        />
      </Col>
      <Col>
        <MultiSelect
          label={t`Workload name`}
          name='workload_names'
          onChange={onChange}
          options={transform('workloadNames')}
          selected={params.workload_names}
        />
      </Col>
    </DashboardFilters>
  )
}
